import styled from "styled-components"
import { SupTitle } from "../../../../utils/GlobalComponents"

export const Wrapper = styled.div``

export const TopTitle = styled(SupTitle)`
  display: block;
  margin-bottom: 40px;
  margin-left: 55px;
`